import type { tProduct } from 'src/shared/frontendTypes/product'

/** The existing compact purchased-card eligibility, shared with the SSR shell. */
export const isRenderablePurchasedProduct = (value: unknown): value is tProduct => {
  if (!value || typeof value !== 'object') return false
  const product = value as Partial<tProduct>
  return Boolean(product.id && product.metaTitle && product.images?.length && product.combinations?.length)
}
